import { render, staticRenderFns } from "./ProductPricingCalculation.vue?vue&type=template&id=57efde8d&"
import script from "./ProductPricingCalculation.vue?vue&type=script&lang=ts&"
export * from "./ProductPricingCalculation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports